import React, { useEffect, useState } from 'react';
import { useSettings } from '../context/SettingContext';
const SplashScreen: React.FC<{ onFinish: () => void }> = ({ onFinish }) => {
    const [progress, setProgress] = useState(0);
    const settings=useSettings()
    useEffect(() => {
        // Auto-hide after 3 seconds
        const timer = setTimeout(() => {
            onFinish();
        }, 3000);

        // Progress bar animation
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 2;
            });
        }, 50);

        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [onFinish]);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
         // background: 'linear-gradient(135deg, #134e4a 0%, #042f2e 100%)',
          //  background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)',
        //   background: 'linear-gradient(135deg, #18181b 0%, #000000 100%)',
        //    background: 'linear-gradient(135deg, #1E3A5F 0%, #0F1E2E 100%)',
        background: "radial-gradient(circle at 50% -20%, #1e293b, #0f172a, #070a12)",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999,
            color: '#fff',
            fontFamily: 'Arial, sans-serif',
            overflow: 'hidden'
        }}>
            {/* Animated Background Circles */}
            <div style={{
                position: 'absolute',
                top: '10%',
                right: '10%',
                width: 200,
                height: 200,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                animation: 'pulse 3s ease-in-out infinite'
            }} />
            <div style={{
                position: 'absolute',
                bottom: '15%',
                left: '10%',
                width: 150,
                height: 150,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                animation: 'pulse 3s ease-in-out infinite 1s'
            }} />

            {/* CSS Animations */}
            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 0.5; }
                    50% { transform: scale(1.2); opacity: 0.2; }
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes scaleIn {
                    from {
                        opacity: 0;
                        transform: scale(0.5);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                
                @keyframes shimmer {
                    0% { background-position: -200% 0; }
                    100% { background-position: 200% 0; }
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }
                    @media (max-width: 600px) {
    h1 { font-size: 28px !important; }
    h2 { font-size: 14px !important; }
    .logo-box { width: 80px !important; height: 80px !important; }
}
            `}</style>

            {/* Logo Section */}
            <div style={{
                animation: 'scaleIn 1s ease-out',
                marginBottom: 30
            }}>
                <div style={{
                    width: 120,
                    height: 120,
                    background: 'linear-gradient(135deg, #ffffff, #F8FAFC)',
                    borderRadius: 24,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    animation: 'float 3s ease-in-out infinite'
                }}>
                    <i className="ri-building-4-fill" style={{
                        fontSize: 70,
                        background: 'linear-gradient(135deg, #1E3A5F, #0F1E2E)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                    }} />
                </div>
            </div>

            {/* Company Name */}
            <div style={{
                animation: 'fadeInUp 1s ease-out 0.3s both',
                textAlign: 'center'
            }}>
                <h1 style={{
                    fontSize: 36,
                    fontWeight: 800,
                    margin: 0,
                    letterSpacing: 3,
                    background: 'linear-gradient(90deg, #ffffff, #cbd5e1, #ffffff)',
                    backgroundSize: '200% auto',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    animation: 'shimmer 3s linear infinite'
                }}>
                    {settings.building_name}
                </h1>
                <h2 style={{
                    fontSize: 18,
                    fontWeight: 400,
                    margin: '5px 0 0',
                    letterSpacing: 8,
                    color: '#94a3b8'
                }}>
                    {settings.site_name}
                </h2>
            </div>

            {/* Divider Line */}
            <div style={{
                width: 100,
                height: 2,
                background: 'linear-gradient(90deg, transparent, #64748b, transparent)',
                margin: '30px 0',
                animation: 'fadeInUp 1s ease-out 0.6s both'
            }} />

            {/* Tagline */}
            <p style={{
                fontSize: 14,
                color: '#94a3b8',
                margin: 0,
                letterSpacing: 1,
                animation: 'fadeInUp 1s ease-out 0.9s both'
            }}>
                Smart Maintenance • Easy Management
            </p>

            {/* Loading Bar */}
            <div style={{
                marginTop: 60,
                width: 240,
                animation: 'fadeInUp 1s ease-out 1.2s both'
            }}>
                <div style={{
                    width: '100%',
                    height: 4,
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: 4,
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    <div style={{
                        width: `${progress}%`,
                        height: '100%',
                        background: 'linear-gradient(90deg, #3B82F6, #60A5FA, #3B82F6)',
                        backgroundSize: '200% auto',
                        animation: 'shimmer 1s linear infinite',
                        transition: 'width 0.3s ease',
                        borderRadius: 4
                    }} />
                </div>
                <div style={{
                    textAlign: 'center',
                    marginTop: 12,
                    fontSize: 12,
                    color: '#64748b',
                    letterSpacing: 1
                }}>
                    Loading {progress}%
                </div>
            </div>

            {/* Bottom Branding */}
            <div style={{
                position: 'absolute',
                bottom: 30,
                textAlign: 'center',
                animation: 'fadeInUp 1s ease-out 1.5s both'
            }}>
                <div style={{
                    fontSize: 11,
                    color: '#64748b',
                    letterSpacing: 2
                }}>
                    POWERED BY
                </div>
                <div style={{
                    fontSize: 14,
                    color: '#fff',
                    fontWeight: 600,
                    marginTop: 4,
                    letterSpacing: 1
                }}>
                    WODEX WEB
                </div>
            </div>
        </div>
    );
};

export default SplashScreen;